import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import Vuikit from 'vuikit'
import VuikitIcons from '@vuikit/icons'

import VueResource from 'vue-resource'

import '@/btoaUTF8patch'

Vue.use(VueResource)

import '@vuikit/theme'

Vue.use(Vuikit)
Vue.use(VuikitIcons)

import { Icon } from 'leaflet'
import 'leaflet/dist/leaflet.css'

delete Icon.Default.prototype._getIconUrl;

Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png')
})

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
